import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { asyncAction } from 'store/utils/promiseAction';
import {
  BenefitsTypes,
  BenefitInterface,
  BenefitLineInterface,
  OperationTypes,
} from './types';

// List Benefits
export const listBenefitsRequest = (payload: {
  params?: object;
  loading?: boolean;
}) => action(BenefitsTypes.LIST_BENEFITS_REQUEST, payload);
export const listBenefitsSuccess = (payload: {
  benefitsList: BenefitInterface[];
  totalCount: number;
}) => action(BenefitsTypes.LIST_BENEFITS_SUCCESS, payload);
export const listBenefitsFailure = () =>
  action(BenefitsTypes.LIST_BENEFITS_FAILURE);

// Get Benefit
export const getBenefitRequest = (payload: object) =>
  asyncAction(BenefitsTypes.GET_BENEFIT_REQUEST, payload);
export const getBenefitSuccess = (payload: { benefitData: BenefitInterface }) =>
  action(BenefitsTypes.GET_BENEFIT_SUCCESS, payload);
export const getBenefitFailure = () =>
  action(BenefitsTypes.GET_BENEFIT_FAILURE);

// Create Benefit
export const createBenefitRequest = (payload: any) =>
  action(BenefitsTypes.CREATE_BENEFIT_REQUEST, payload);
export const createBenefitSuccess = (payload: {
  benefitCreated: BenefitInterface;
}) => action(BenefitsTypes.CREATE_BENEFIT_SUCCESS, payload);
export const createBenefitFailure = () =>
  action(BenefitsTypes.CREATE_BENEFIT_FAILURE);

// Benefit Attach
export const attachBenefitRequest = (payload: any) =>
  action(BenefitsTypes.ATTACH_BENEFIT_REQUEST, payload);
export const attachBenefitSuccess = (payload: {
  attachBenefit: BenefitInterface;
}) => action(BenefitsTypes.ATTACH_BENEFIT_SUCCESS, payload);
export const attachBenefitFailure = () =>
  action(BenefitsTypes.ATTACH_BENEFIT_FAILURE);

// Update Benefit
export const updateBenefitRequest = (payload: any) =>
  action(BenefitsTypes.UPDATE_BENEFIT_REQUEST, payload);
export const updateBenefitSuccess = () =>
  action(BenefitsTypes.UPDATE_BENEFIT_SUCCESS);
export const updateBenefitFailure = () =>
  action(BenefitsTypes.UPDATE_BENEFIT_FAILURE);

// Delete Benefit
export const deleteBenefitRequest = (payload: object) =>
  action(BenefitsTypes.DELETE_BENEFIT_REQUEST, payload);
export const deleteBenefitSuccess = () =>
  action(BenefitsTypes.DELETE_BENEFIT_SUCCESS);
export const deleteBenefitFailure = () =>
  action(BenefitsTypes.DELETE_BENEFIT_FAILURE);

// List Benefit Lines
export const listBenefitLinesRequest = (payload: object) =>
  action(BenefitsTypes.LIST_BENEFIT_LINES_REQUEST, payload);
export const listBenefitLinesSuccess = (payload: {
  benefitLines: BenefitLineInterface;
}) => action(BenefitsTypes.LIST_BENEFIT_LINES_SUCCESS, payload);
export const listBenefitLinesFailure = () =>
  action(BenefitsTypes.LIST_BENEFIT_LINES_FAILURE);

// Set Current Operation
export const setCurrentOperation = (payload: { operation: OperationTypes }) =>
  action(BenefitsTypes.SET_CURRENT_OPERATION, payload);

// Set Benefit Selected
export const setBenefitSelected = (payload: {
  benefitSelected: BenefitInterface;
}) => action(BenefitsTypes.SET_BENEFIT_SELECTED, payload);

// Reset Benefit Selected
export const resetBenefitSelected = () =>
  action(BenefitsTypes.RESET_BENEFIT_SELECTED);
